export interface SpendAndSavingsSummary {
  continuedSpend: number;
  plannedSpend: number;
  complianceSpend: number;
  savings: number | null;
  savingsPercent: number | null;
  excludedSpend: number | null;
}

// Don't like the name but SpendAndSavingsSummaryFilter is already in use
// This is the actual function signature expected when actually invoking the filter.
export type SpendAndSavingsSummaryFilterFn = (
  continuedSpend: number,
  plannedSpend: number,
  complianceSpend: number
) => SpendAndSavingsSummary;

export default function SpendAndSavingsSummaryFilter(): SpendAndSavingsSummaryFilterFn {
  /**
   * @description: calculate savings, savings percent and excluded spend, and return an object including spend values
   * @example continuedSpend | spendAndSavingsSummary:plannedSpend:complianceSpend
   * or spendAndSavingsSummary(continuedSpend, plannedSpend, complianceSpend) - because this returns an object it is best to not
   * bind to the returned object in a template otherwise infinite digests may occur.
   * @param {number} continuedSpend;
   * @param {number} plannedSpend;
   * @param {number} complianceSpend;
   * @return {SpendAndSavingsSummary}
   */
  return (
    continuedSpend: number,
    plannedSpend: number,
    complianceSpend: number
  ): SpendAndSavingsSummary => {
    const savings = plannedSpend
      ? (continuedSpend || 0) - (plannedSpend || 0)
      : null;

    const savingsPercent = plannedSpend
      ? Math.round((savings / (continuedSpend || 0)) * 100)
      : null;

    const excludedSpend =
      complianceSpend != null
        ? Math.trunc(plannedSpend || 0) - Math.trunc(complianceSpend || 0)
        : 0;

    // when this goes into prod we can enable this assertion
    // console.assert(complianceSpend != 0, 'complianceSpend should be a number')

    return {
      continuedSpend,
      plannedSpend,
      complianceSpend,
      savings,
      savingsPercent,
      excludedSpend
    } as SpendAndSavingsSummary;
  };
}
